import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const { itemId, title, itemMainPic, salePriceFormat } = product;

  return (
    <Card className="h-100 shadow-sm">
                <img
                  src="https://ae01.alicdn.com/kf/Sa0202ec8a96a4085962acfc27e9ffd04F/1080x1080.jpg"
                  alt="AliExpress"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    width: '60px',
                    borderRadius: '50%',
                    zIndex: 2,
               
                    backgroundColor: '#fff',
                    padding: '3px',
                  }}
                />
      <Card.Img variant="top" src={itemMainPic} style={{ height: '150px', objectFit: 'cover' }} />
      <Card.Body className="d-flex flex-column">
        <Card.Title className="small">{title}</Card.Title>
        <Card.Text className="fw-bold text-success">{salePriceFormat}</Card.Text>
        <Link to={`/aliproduct/${itemId}`} className="btn btn-primary btn-sm mt-auto">View Details</Link>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;
